module.exports = __webpack_public_path__ + "static/01-7422f0f6de3d93314e1dfea4ec14b8b6.jpg";